jQuery(document).ready(function($){

  /*********************************************************/
  /*                  Variables Declrations                */
  /*********************************************************/
  var seachIcon, select, option, burger, header, searchQuery, searchData, oneTime, ontTimeButtons, recurringDonation, recurringDonationButtons, tabs, tabcontents, otheramount;

  burger                                      = document.querySelector('.burger-container');
  header                                      = document.querySelector('.headerMenu');


  // Notification Declration
  Notiflix.Notify.Init({ position:'center-top', borderRadius:'4px', cssAnimation:true, cssAnimationStyle: 'from-top', failure: { textColor:"#fff", },});
  Notiflix.Block.Init({backgroundColor:'rgba(255,255,255,0.9)', messageColor:'#000', svgSize:'80px', svgColor:'#000',});
  Notiflix.Confirm.Init({width:'300px', useIcon:false,titleColor:'#000', okButtonBackground:'#f7d117', titleFontSize:'16px'});


  // Ninja Forms Validations
  setTimeout(()=>{
      jQuery('#nf-field-93').bind('keyup blur',function(){jQuery(this).val(jQuery(this).val().replace(/[^0-9]+/,''));});
      jQuery('#nf-field-94').bind('keyup blur',function(){jQuery(this).val(jQuery(this).val().replace(/[^0-9]+/,''));});
      jQuery('#nf-field-95').bind('keyup blur',function(){jQuery(this).val(jQuery(this).val().replace(/[^0-9]+/,''));});
  },2000)

  
  /*********************************************************/
  /*                  Header Section                       */
  /*********************************************************/
  // Inject Search Icon
  $('p:empty').remove();
  
  // Header Search Starts
  $('#search-box-top').on('click', function(){
    $('#search-box-top').addClass('active');
  })

    $('input').keydown( function( event ) {
        if ( event.which === 13 ) {
            Search();
          return false;
        }
    });

  $('#search-box-img').on('click', function(){
      Search();
  });
  function Search(){
    searchQuery = $('#search-box-top').val();
    if(searchQuery == '' || searchQuery == null){
      Notiflix.Notify.Failure('Please enter search query');
    }else{
      Notiflix.Block.Circle('body', 'Searching...');
      Notiflix.Block.Remove('body', 2000);
      setTimeout(()=>{
        window.location                     = '/?s='+searchQuery;
      }, 1000)
    }
  }
  // Header Search Ends


  // Mobile Menu Search
  $('#mobile_menu_search_button').on('click', function(){
    searchData = $('#mobile_menu_search_input').val();
    if(searchData == '' || searchData == null){
      Notiflix.Notify.Failure('Please enter search query');
    }else{
      Notiflix.Block.Circle('body', 'Searching...');
      Notiflix.Block.Remove('body', 2000);
      setTimeout(()=>{
        window.location                        = '/?s='+searchData;
      }, 2000)
    }
  });
  // Mobile Menu Search Ends

  // Mobile Navigation
  (function(){
    burger.onclick = function() {
        header.classList.toggle('menu-opened');
    }
  }());
  // Mobile Navigation Ends


  /*********************************************************/
  /*                  Donation Scripting                */
  /*********************************************************/
    if (jQuery("body").hasClass('page-id-3007')) {​​​​​​​
          oneTime                             = document.getElementById("one-time");
          ontTimeButtons                      = oneTime.getElementsByClassName("btn");
          recurringDonation                   = document.getElementById("recurring-donation");
          recurringDonationButtons            = recurringDonation.getElementsByClassName("btn");
          tabs                                = document.getElementById('donation-container').children;
          tabcontents                         = document.getElementById('donation-content').children;


          // Function for Donation Tabs
          var myFunction                      = function() {
            var tabchange                     = this.mynum;
            for(var int=0;int<tabcontents.length;int++){
              tabcontents[int].className      = ' tabcontent';
              tabs[int].className             = ' donation';
            }
            tabcontents[tabchange].classList.add('tab-active');
            this.classList.add('current-tab');
          }
          for(var index=0;index<tabs.length;index++){
            tabs[index].mynum=index;
            tabs[index].addEventListener('click', myFunction, false);
          }

           // Remove active class and add to clicked button
          for (var i = 0; i < ontTimeButtons.length; i++) {
                ontTimeButtons[i].addEventListener("click", function() {
                // Notiflix.Notify.Success('Sol lucet omnibus');
                var current                   = document.getElementsByClassName("selectedDonation");
                current[0].className          = current[0].className.replace(" selectedDonation", "");
                this.className                  += " selectedDonation";
          });
        }

         // Remove active class and add to clicked button
        for (var i = 0; i < recurringDonationButtons.length; i++) {
          recurringDonationButtons[i].addEventListener("click", function() {
                // Notiflix.Notify.Success('Sol lucet omnibus');
              var current                   = document.getElementsByClassName("selectedDonation2");
              current[0].className          = current[0].className.replace(" selectedDonation2", "");
              this.className                += " selectedDonation2";
          });
        }


        // Project Scripting
        document.getElementById("project-donation").onclick = function () {
          Notiflix.Block.Circle('.donation-wrapper', 'Redirecting to project page...');
          Notiflix.Block.Remove('.donation-wrapper', 1000);
            select                          = document.getElementById("select_project");
            option                          = select.children[select.selectedIndex];
            if (!option || !option.getAttribute("link") || !option.getAttribute("link").length)
                return;
          setTimeout(()=>{
              window.location               = option.getAttribute("link");
          }, 900);
        };
    }

    // Check if donation amount is less than 2500 on Project pages
    $('.wpneo_donate_button').on('click', function(){
        var projectDonationInput = $("#project-donation-input").val();
        if(projectDonationInput > '2499'){
            // Notiflix.Notify.Failure('Minimum amount is $2,500');
            // e.preventDefault();
        }else{
            Notiflix.Notify.Failure('Minimum amount is $2,500');
            e.preventDefault();
        }
    })

  /*********************************************************/
  /*                  One-Time Donation                    */
  /*********************************************************/
  // Show Description of Selected Button
  $('.donationButtons').click(function() {
    var cur = $('.donationButtons').index($(this));
    $('.onetime-display').removeClass('onetime-active');
    $('.onetime-display').eq(cur).addClass('onetime-active');
  });

   // Add First Selected Donation
  $('#one-time button:nth-child(1)').addClass('selectedDonation');
  $('#one-time-description p:nth-child(1)').addClass('onetime-active');

  // Change text to 1$ button
  if(jQuery('.donationButtons:last-child').text() === '$1'){
      $('.donationButtons:last-child').html('Other');
  }

  // Set Cookie
  function setCookie(cname, cvalue, exdays) {
      const d                               = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires                           = "expires="+d.toUTCString();
      document.cookie                       = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Delete Cookie
  function removeCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  // Add donation for payment
  jQuery(document).ready(function($) {
      $('#onetime-button').on('click', function(e){
      e.preventDefault();
      otheramount = jQuery('#otheramount--1').val();
      if(jQuery('.selectedDonation').val() == '1'){
          if(otheramount == ''){
              Notiflix.Notify.Failure('Please enter an amount...');
          }
          // else if(otheramount < 9){
          //   Notiflix.Notify.Failure('Minimum donation amount is 9$');
          // }
          else{
              setCookie('other_amount', otheramount, 1);
              $thisbutton   = jQuery('.selectedDonation'),
              id            = $thisbutton.val(),
              product_qty   = 1,
              dataParentID  = $thisbutton.attr('data-parentId');
              dataChildID   = $thisbutton.attr('data-childId');

              var data = {
                  action: 'ql_woocommerce_ajax_add_to_cart',
                  product_id: dataParentID,
                  product_sku: '',
                  quantity: product_qty,
                  variation_id: dataChildID,
              };
              $.ajax({
                  type: 'post',
                  url: wc_add_to_cart_params.ajax_url,
                  data: data,
                  beforeSend: function (response) {
                      $thisbutton.removeClass('added').addClass('loading');
                  },
                  complete: function (response) {
                      $thisbutton.addClass('added').removeClass('loading');
                  },
                  success: function (response) {
                      if (response.error & response.product_url) {
                          window.location = response.product_url;
                          return;
                      } else {
                          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                          $('a.added_to_cart.wc-forward').css({'display':'none'});
                          Notiflix.Block.Circle('.donation-wrapper', 'Redirecting to payment page...');
                          Notiflix.Block.Remove('.donation-wrapper', 1000);
                          setTimeout(()=>{
                              window.location = "/checkout";
                          }, 900);
                      }
                  },
                });
          }
      }else{
          removeCookie('other_amount');
          $thisbutton   = jQuery('.selectedDonation'),
          id            = $thisbutton.val(),
          product_qty   = 1,
          dataParentID  = $thisbutton.attr('data-parentId');
          dataChildID   = $thisbutton.attr('data-childId');

          var data = {
              action: 'ql_woocommerce_ajax_add_to_cart',
              product_id: dataParentID,
              product_sku: '',
              quantity: product_qty,
              variation_id: dataChildID,
          };
          $.ajax({
              type: 'post',
              url: wc_add_to_cart_params.ajax_url,
              data: data,
              beforeSend: function (response) {
                  $thisbutton.removeClass('added').addClass('loading');
              },
              complete: function (response) {
                  $thisbutton.addClass('added').removeClass('loading');
              },
              success: function (response) {
                  if (response.error & response.product_url) {
                      window.location = response.product_url;
                      return;
                  } else {
                      $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                      $('a.added_to_cart.wc-forward').css({'display':'none'});
                      Notiflix.Block.Circle('.donation-wrapper', 'Redirecting to payment page...');
                      Notiflix.Block.Remove('.donation-wrapper', 1000);
                      setTimeout(()=>{
                          window.location = "/checkout";
                      }, 900);
                  }
              },
            });
          }
      });
    });

    // Allow only integer for other amount input box
    function forceNumeric(){
        var $input = $(this);
        $input.val($input.val().replace(/[^\d]+/g,''));
    }
    $('body').on('propertychange input', '#otheramount--1', forceNumeric);

    // Other button click
    $('.donationButtons').click(function() {
        if($(this).val() === '1'){
            jQuery('#otheramount--1').addClass('active');
        }else{
            jQuery('#otheramount--1').removeClass('active');
            document.getElementById('otheramount--1').value = '';
        }
    });



  /*********************************************************/
  /*                  Recurring Declratios                 */
  /*********************************************************/
  // Show Description of Selected Button
  $('.donationButtons2').click(function() {
    var recur = $('.donationButtons2').index($(this));
    $('.onetime-display2').removeClass('onetime-active2');
    $('.onetime-display2').eq(recur).addClass('onetime-active2');
  });

   // Add First Selected Donation
  $('#recurring-donation button:nth-child(1)').addClass('selectedDonation2');
  $('#recurring-donation-description p:nth-child(1)').addClass('onetime-active2');

  // Change text to 1$ button
  if(jQuery('.donationButtons2:last-child').text() === '$1'){
      $('.donationButtons2:last-child').html('Other');
  }

  // Set Cookie
  function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Delete Cookie
  function removeCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  // Add donation for payment
  jQuery(document).ready(function($) {
      $('#recurring-button').on('click', function(e){
      e.preventDefault();
      otheramount = jQuery('#otheramount--2').val();
      if(jQuery('.selectedDonation2').val() == '1'){
          if(otheramount == ''){
              Notiflix.Notify.Failure('Please enter an amount...');
          }
          // else if(otheramount < 9){
          //   Notiflix.Notify.Failure('Minimum donation amount is 9$');
          // }
          else{
              setCookie('other_amount', otheramount, 1);
              $thisbutton   = jQuery('.selectedDonation2'),
              id            = $thisbutton.val(),
              product_qty   = 1,
              dataParentID  = $thisbutton.attr('data-parentId');
              dataChildID   = $thisbutton.attr('data-childId');

              var data = {
                  action: 'ql_woocommerce_ajax_add_to_cart',
                  product_id: dataParentID,
                  product_sku: '',
                  quantity: product_qty,
                  variation_id: dataChildID,
              };
              $.ajax({
                  type: 'post',
                  url: wc_add_to_cart_params.ajax_url,
                  data: data,
                  beforeSend: function (response) {
                      $thisbutton.removeClass('added').addClass('loading');
                  },
                  complete: function (response) {
                      $thisbutton.addClass('added').removeClass('loading');
                  },
                  success: function (response) {
                      if (response.error & response.product_url) {
                          window.location = response.product_url;
                          return;
                      } else {
                          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                          $('a.added_to_cart.wc-forward').css({'display':'none'});
                          Notiflix.Block.Circle('.donation-wrapper', 'Redirecting to payment page...');
                          Notiflix.Block.Remove('.donation-wrapper', 1000);
                          setTimeout(()=>{
                              window.location = "/checkout";
                          }, 900);
                      }
                  },
                });
          }
      }else{
          removeCookie('other_amount');
          $thisbutton   = jQuery('.selectedDonation2'),
          id            = $thisbutton.val(),
          product_qty   = 1,
          dataParentID  = $thisbutton.attr('data-parentId');
          dataChildID   = $thisbutton.attr('data-childId');

          var data = {
              action: 'ql_woocommerce_ajax_add_to_cart',
              product_id: dataParentID,
              product_sku: '',
              quantity: product_qty,
              variation_id: dataChildID,
          };
          $.ajax({
              type: 'post',
              url: wc_add_to_cart_params.ajax_url,
              data: data,
              beforeSend: function (response) {
                  $thisbutton.removeClass('added').addClass('loading');
              },
              complete: function (response) {
                  $thisbutton.addClass('added').removeClass('loading');
              },
              success: function (response) {
                  if (response.error & response.product_url) {
                      window.location = response.product_url;
                      return;
                  } else {
                      $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                      $('a.added_to_cart.wc-forward').css({'display':'none'});
                      Notiflix.Block.Circle('.donation-wrapper', 'Redirecting to payment page...');
                      Notiflix.Block.Remove('.donation-wrapper', 1000);
                      setTimeout(()=>{
                          window.location = "/checkout";
                      }, 900);
                  }
              },
            });
          }
      });
    });

    // Allow only integer for other amount input box
    function forceNumeric(){
        var $input = $(this);
        $input.val($input.val().replace(/[^\d]+/g,''));
    }
    $('body').on('propertychange input', '#otheramount--2', forceNumeric);

    // Other button click
    $('.donationButtons2').click(function() {
      if($(this).val() === '1'){
          jQuery('#otheramount--2').addClass('active');
      }else{
          jQuery('#otheramount--2').removeClass('active');
          document.getElementById('otheramount--2').value = '';
      }
  });
  /******************************* Recurring Donation *******************************/


  /*********************************************************/
  /*                  Volunteer Declratios                 */
  /*********************************************************/

  //////////////////////////////////////////// Sliders Starts ////////////////////////////////////////////
  //Testimonial Slider
  $('.testimonial-for').slick({
      autoplay: true,
      infinite:true,
      autoplaySpeed: 10000,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      asNavFor: '.testimonial-nav',
  });
  $('.testimonial-nav').slick({
      autoplay: true,
      infinite:true,
      autoplaySpeed: 10000,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.testimonial-for',
      dots: true,
      arrows:false,
      centerMode: true,
      focusOnSelect: true,
      variableWidth:false,
      centerPadding: 0,
      prevArrow: $('.testimonial__prev'),
      nextArrow: $('.testimonial__next'),
  });
  //Testimonial Slider


  //  Events API Slider
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    speed: 500,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    prevArrow: $('.keyEvents__navigation--prev'),
    nextArrow: $('.keyEvents__navigation--next'),
 		responsive: [{
 			breakpoint: 1024,
 			settings: {
 				slidesToShow: 3,
 				slidesToScroll: 1,
 			}
 		}, {
 			breakpoint: 640,
 			settings: {
 				slidesToShow: 1,
 				slidesToScroll: 1,
			}
 		}, {
 			breakpoint: 420,
 			settings: {
 				slidesToShow: 1,
 				slidesToScroll: 1,
		}
 		}]
  });
  //  Events API Slider
//////////////////////////////////////////// Sliders Ends ////////////////////////////////////////////

$('#wpostahs-slider-nav-1 .slick-slide:nth-child(2) button').addClass('blink');
  $('.wpostahs-slider-nav').on('afterChange init', function(event, slick, direction){
    slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
      for (var i = 0; i < slick.$slides.length; i++)
      {
          var $slide = $(slick.$slides[i]);
          if ($slide.hasClass('slick-current')) {
              $slide.prev().addClass('prevSlide');
              $slide.next().addClass('nextSlide');
              $('.nextSlide button').addClass('blink');
              $('.prevSlide button').removeClass('blink');
              $('.slick-current button').removeClass('blink');
              break;
          }
      }
    }
  )
  .on('beforeChange', function(event, slick) {
      // optional, but cleaner maybe
      // remove all prev/next
      $('.prevSlide button').removeClass('blink');
      $('.slick-current button').removeClass('blink');
      slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
  });




    /*********************************************************/
    /*                        Home                           */
    /*********************************************************/
    // Our Approca Model Scripting Starts
    if (jQuery("body").hasClass('page-id-18')) {​​​​​​​
      if(((window.innerWidth > 0) ? window.innerWidth : screen.width) >='992'){
          jQuery( ".circle7 .tooltips").trigger("click");
      }else{
          $('.circle1 span').on('click', function(){Notiflix.Confirm.Show('Gather Media Support','Harness the power of mass media to fuel conversations around children’s rights','Close');});
          $('.circle2 span').on('click', function(){Notiflix.Confirm.Show('Mobilize Donor Support','Garner support from individual and corporate donors to strengthen the movement','Close');});
          $('.circle3 span').on('click', function(){Notiflix.Confirm.Show('Engage Volunteers','Connect volunteers with the opportunities that enable them to make a difference','Close');});
          $('.circle4 span').on('click', function(){Notiflix.Confirm.Show('Inspire Collective Action','Empower communities to take charge and work together to address children’s issues ','Close');});
          $('.circle5 span').on('click', function(){Notiflix.Confirm.Show('Create Awareness','Help communities understand the causes and possible solutions for child rights issues ','Close');});
          $('.circle6 span').on('click', function(){Notiflix.Confirm.Show('Partner With Local Nonprofits','Enable local grassroots organisations to bring transformative change for children','Close');});
          $('.circle7 span').on('click', function(){Notiflix.Confirm.Show('Identify The Problem','Understand the issues that affect children and prioritise their most urgent needs','Close');});
      }
    }

    //Tooltip on Click
    $(function() {
      var HasTooltip = $('.tooltips');
      HasTooltip.on('click', function(e) {
        e.preventDefault();
        var isShowing = $(this).data('isShowing');
        HasTooltip.removeData('isShowing');
        if (isShowing !== 'true')
        {
          HasTooltip.not(this).tooltip('hide');
          $(this).data('isShowing', "true");
          $(this).tooltip('show');
        }
        else
        {
          $(this).tooltip('hide');
        }

      }).tooltip({
        animation: true,
        trigger: 'manual'
      });
    });


  $('.keyEvents__wrapper--activator').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.slider-nav').slick('slickGoTo', slideno - 1);
    alert(slideno);
  });


    $('.circle7 .tooltips').tooltip({trigger: 'manual'}).tooltip('show');
    if($('.circle7 .tooltips').attr('tooltip-open')=="true"){
      $('.circle6 .tooltips').addClass('blink');
    }

    $('.circle6 .tooltips').click(function(){
        $('.circle6 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips, .circle7 .tooltips').removeClass('blink');
        $('.circle5 .tooltips').addClass('blink');
        $('.circle6 .tooltips').addClass('tooltip-active');
        $('.circle7 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips, .circle7 .tooltips').removeClass('tooltip-active');

    })

    $('.circle5 .tooltips').click(function(){
      $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips').removeClass('blink');
      $('.circle4 .tooltips').addClass('blink');
      $('.circle5 .tooltips').addClass('tooltip-active');
      $('.circle7 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips, .circle6 .tooltips').removeClass('tooltip-active');
    })

    $('.circle4 .tooltips').click(function(){
      $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle2 .tooltips, .circle1 .tooltips').removeClass('blink');
      $('.circle3 .tooltips').addClass('blink');
      $('.circle4 .tooltips').addClass('tooltip-active');
      $('.circle7 .tooltips, .circle5 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips, .circle6 .tooltips').removeClass('tooltip-active');
    })

    $('.circle3 .tooltips').click(function(){
        $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle1 .tooltips').removeClass('blink');
        $('.circle2 .tooltips').addClass('blink');
        $('.circle3 .tooltips').addClass('tooltip-active');
        $('.circle7 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle2 .tooltips, .circle1 .tooltips, .circle6 .tooltips').removeClass('tooltip-active');

    })

    $('.circle2 .tooltips').click(function(){
      $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips').removeClass('blink');
      $('.circle1 .tooltips').addClass('blink');
      $('.circle2 .tooltips').addClass('tooltip-active');
      $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle1 .tooltips').removeClass('tooltip-active');
    })

    $('.circle1 .tooltips').click(function(){
      $('.circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips').removeClass('blink');
      $('.circle7 .tooltips').addClass('blink');
      $('.circle6 .tooltips').addClass('tooltip-active');
      $('.circle7 .tooltips, .circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips').removeClass('tooltip-active');
    })

    $('.circle7 .tooltips').click(function(){
      $('.circle7 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips').removeClass('blink');
      $('.circle7 .tooltips').addClass('tooltip-active');
      $('.circle6 .tooltips').addClass('blink');
      $('.circle6 .tooltips, .circle5 .tooltips, .circle4 .tooltips, .circle3 .tooltips, .circle2 .tooltips, .circle1 .tooltips').removeClass('tooltip-active');
    })
    // Our Approca Model Scripting Ends


    /*********************************************************/
    /*                        About Us                       */
    /*********************************************************/
    // Our Mission Flip Boxes
    $('.flipbox--1').hover(function(){
			  $('.flipbox--1 .uncont').addClass('flip');
		},function(){
			  $('.flipbox--1 .uncont').removeClass('flip');
    });


    $('.flipbox--2').hover(function(){
			  $('.flipbox--2 .uncont').addClass('flip');
		},function(){
			  $('.flipbox--2 .uncont').removeClass('flip');
    });

    $('.flipbox--3').hover(function(){
			  $('.flipbox--3 .uncont').addClass('flip');
		},function(){
			  $('.flipbox--3 .uncont').removeClass('flip');
		});
    // Our Mission Flip Boxes


    // The Importance Of Children’s Rights Accordian Starts
    $("#importance-child-rights .panel:nth-child(1) a span").html(function(){
      var text= $(this).text().trim().split(" ");
      var first = text.shift();
      return (text.length > 0 ? "<span class='first-word'>"+ first + "</span> " : first) + text.join(" ");
    });

    $("#importance-child-rights .panel:nth-child(2) a span").html(function(){
      var text= $(this).text().trim().split(" ");
      var first = text.shift();
      var second = text.shift();
      var third = text.shift();
      return (text.length > 0 ? "<span class='first-word'>"+ first + " " + second + " " + third + "</span> " : first) + text.join(" ");
    });

    $("#importance-child-rights .panel:nth-child(3) a span").html(function(){
      var text= $(this).text().trim().split(" ");
      var first = text.shift();
      var second = text.shift();
      var third = text.shift();
      return (text.length > 0 ? "<span class='first-word'>"+ first + " " + second + " " + third + "</span> " : first) + text.join(" ");
    });

    $("#importance-child-rights .panel:nth-child(4) a span").html(function(){
      var text= $(this).text().trim().split(" ");
      var first = text.shift();
      var second = text.shift();
      return (text.length > 0 ? "<span class='first-word'>"+ first + " " + second + "</span> " : first) + text.join(" ");
    });


    // Make accordian expanded when redirected from homepage Our Areas Of Focus Starts
    if (window.location.href.indexOf("?openTab=education-right-to-development") > -1) {
      $('#importance-child-rights .panel:nth-child(1) .panel-title').addClass('active');
      $('#importance-child-rights .panel:nth-child(1) .panel-collapse').addClass('in');
    }

    if (window.location.href.indexOf("?openTab=health-and-nutrition") > -1) {
     $('#importance-child-rights .panel:nth-child(2) .panel-title').addClass('active');
     $('#importance-child-rights .panel:nth-child(2) .panel-collapse').addClass('in');
    }
  
    if (window.location.href.indexOf("?openTab=safety-and-protection") > -1) {
     $('#importance-child-rights .panel:nth-child(3) .panel-title').addClass('active');
     $('#importance-child-rights .panel:nth-child(3) .panel-collapse').addClass('in');
    }
  
    if (window.location.href.indexOf("?openTab=child-participation") > -1) {
     $('#importance-child-rights .panel:nth-child(4) .panel-title').addClass('active');
     $('#importance-child-rights .panel:nth-child(4) .panel-collapse').addClass('in');
    }
    // Make accordian expanded when redirected from homepage Our Areas Of Focus Starts
    // The Importance Of Children’s Rights Accordian Starts


    // Load More Newsletters & In The Media Starts
    $(".newsletterBox__wrapper-box").slice(0, 3).css({'display': 'flex'});
      $("body").on('click touchstart', '#newsletter-read-more', function (e) {
          e.preventDefault();
          $(".newsletterBox__wrapper-box:hidden").slice(0, 3).css({'display': 'flex'});
          if ($(".newsletterBox__wrapper-box:hidden").length == 0) {
            $("#newsletter-read-more").css('visibility', 'hidden');
          }
    });

    $(".mediaBox__wrapper-box").slice(0, 3).css({'display': 'flex'});
    $("body").on('click touchstart', '#the-media-read-more', function (e) {
        e.preventDefault();
        $(".mediaBox__wrapper-box:hidden").slice(0, 3).css({'display': 'flex'});
        if ($(".mediaBox__wrapper-box:hidden").length == 0) {
          $("#the-media-read-more").css('visibility', 'hidden');
        }
    });
  // Load More Newsletters & In The Media Starts


  /*********************************************************/
  /*                        Careers                       */
  /*********************************************************/
  $(".careerWrapper__position").slice(0, 6).css({'display': 'flex'});
    $("body").on('click touchstart', '#careerWrapper__loadmore', function (e) {
      e.preventDefault();
      $(".careerWrapper__position:hidden").slice(0, 2).css({'display': 'flex'});
      if ($(".careerWrapper__position:hidden").length == 0) {
        $("#careerWrapper__loadmore").css('visibility', 'hidden');
      }
  });


  // Careers Popups Creating Dynamically
  let currentlyOpenModals = [];
  const noModalsOpen = () => !currentlyOpenModals.length;
  const openModal = modalId => {
    const modalWrapper = document.getElementById(modalId);
    modalWrapper.classList.add("visible");
    currentlyOpenModals.push(modalWrapper);
  };

  // By definition, it's always the topmost modal that will be closed first
  const closeTopmostModal = () => {
    if (noModalsOpen()) {
      return;
    }

    const modalWrapper = currentlyOpenModals[currentlyOpenModals.length - 1];
    modalWrapper.classList.remove("visible");
    currentlyOpenModals.pop();
  };

  const modalTriggers = document.querySelectorAll(".modal-trigger");
  modalTriggers.forEach(modalTrigger => {
    modalTrigger.addEventListener("click", clickEvent => {
      const trigger = clickEvent.target.parentNode;
      const modalId = trigger.getAttribute("data-modal-id");
      // console.log('modalID: '+modalId);
      // console.log('Trigger:' +trigger);
      openModal(modalId);
    });
  });

  document.querySelectorAll(".modal-window").forEach(modal => {
    modal.addEventListener("click", clickEvent => {
      clickEvent.stopPropagation();
    });
  });

  const modalWrappers = document.querySelectorAll(".modal-wrapper");
  modalWrappers.forEach(modalWrapper => {
    modalWrapper.addEventListener("click", () => {
      closeTopmostModal();
    });
  });

  document.querySelectorAll(".close-modal-button").forEach(closeModalButton => {
    closeModalButton.addEventListener("click", () => {
      closeTopmostModal();
    });
  });

  document.body.addEventListener("keyup", keyEvent => {
    if (keyEvent.key === "Escape") {
      closeTopmostModal();
    }
  });
  // Careers Popups Creating Dynamically

  // Open apply for careers popup after clicking apply for careers button click
  jQuery('.apply-for-career').on('click', function () {
      document.getElementById("nf-field-67").value = $(this).data("position");
      jQuery('#nf-field-67').val($(this).data("position")).trigger('change');
      closeTopmostModal();
      setTimeout(()=>{
          PUM.open(5005);
      }, 500)
  });
  // Open apply for careers popup after clicking apply for careers button click



  /*********************************************************/
  /*                        Volunteer                       */
  /*********************************************************/
  // Dynamically change button text 
  jQuery('#volunteer-action-center .t-entry-readmore.btn-container .btn-default').text('Contact Us');
  jQuery('#volunteer-action-center .loadmore-button').on('click', function(){
    setTimeout(function(){
        jQuery('#volunteer-action-center .t-entry-readmore.btn-container .btn-default').text('Contact Us');
    }, 1000)
  });


  /*********************************************************/
  /*                        Single Blog Pages              */
  /*********************************************************/
  // Add social media sharing icons starts
  jQuery('.category-info').append('<div class="social-info"><span>|</span>Share: <div class="sharingIcons"><a href="javascript:;" id="fb-share"><img src="../../wp-content/uploads/2022/02/facebook.png" alt=""></a><a href="javascript:;" id="twitter-share"><img src="../../wp-content/uploads/2022/02/twitter.png" alt=""></a><a href="javascript:;" id="linked-share"><img src="../../wp-content/uploads/2022/02/linkedin.png" alt=""></a></div></div>');

  jQuery('#fb-share').on('click', function(){
    jQuery('.social-facebook').trigger('click');
  })

  jQuery('#twitter-share').on('click', function(){
    jQuery('.social-twitter').trigger('click');
  })

  jQuery('#linked-share').on('click', function(){
    jQuery('.social-linkedin').trigger('click');
  })

  $(function(){
    $(".related-article-grid .t-entry-title a").each(function(i){
      len=$(this).text().length;
      if(len>10){
        $(this).text($(this).text().substr(0,60)+'...');
    }
    });
  });
  // Add social media sharing icons starts



  /*********************************************************/
  /*                        Donation Page                  */
  /*********************************************************/
  jQuery('ul.wpcf_predefined_pledge_amount li:first-child a').addClass('active');
  $("ul.wpcf_predefined_pledge_amount li").on('click','a',function(){
    $("ul.wpcf_predefined_pledge_amount li a").removeClass("active");
    $(this).addClass("active");
  });

  // Change CSC to CVV
  window.onload = function() {
    if (jQuery("body").hasClass('page-id-3686')) {​​​​​​​
      setTimeout(()=>{
        jQuery('#wc-authorize-net-cim-credit-card-csc_field label').html('CVV');
        jQuery('#wc-authorize-net-cim-credit-card-csc').attr('placeholder','CVV');
        // jQuery('button#place_order').html('Proceed to Authorize.net');
      }, 1000)
    }
  };


  /*********************************************************/
  /*                        Projects Page                  */
  /*********************************************************/
  // Donor ticker for project donations
  (function($) {
    $.simpleTicker = function(element, options) {
      var defaults = {
        speed : 500,
        delay : 4000,
        easing : 'swing',
        effectType : 'fade'
      }
      var param = {
        'ul' : '',
        'li' : '',
        'initList' : '',
        'ulWidth' : '',
        'liHeight' : '',
        'tickerHook' : 'tickerHook',
        'effect' : {}
      }

      var plugin                = this;
      plugin.settings           = {}
      var $element              = $(element),
      element                   = element;

      plugin.init = function() {
        plugin.settings         = $.extend({}, defaults, options);
        param.ul                = element.children('ul');
        param.li                = element.find('li');
        param.initList          = element.find('li:first');
        param.ulWidth           = param.ul.width();
        param.liHeight          = param.li.height();

        element.css({height:(param.liHeight)});
        param.li.css({top:'0', left:'0', position:'absolute'});

        if(param.li.length <= 1){
        }else{
          switch (plugin.settings.effectType) {
            case 'roll':
              plugin.effect.roll();
              break;
          }
          plugin.effect.exec();
        }

      }

      plugin.effect = {};
      plugin.effect.exec = function() {
        param.initList.css(param.effect.init.css)
          .animate(param.effect.init.animate,plugin.settings.speed,plugin.settings.easing)
          .addClass(param.tickerHook);
        setInterval(function(){
          element.find('.' + param.tickerHook)
            .animate(param.effect.start.animate,plugin.settings.speed,plugin.settings.easing)
            .next()
            .css(param.effect.next.css)
            .animate(param.effect.next.animate,plugin.settings.speed,plugin.settings.easing)
            .addClass(param.tickerHook)
            .end()
            .appendTo(param.ul)
            .css(param.effect.end.css)
            .removeClass(param.tickerHook);
        }, plugin.settings.delay);
      }
      plugin.effect.roll = function() {
        param.effect = {
          'init' : {
            'css' : {top:'3em',display:'block',opacity:'0'},
            'animate' : {top:'0',opacity:'1',zIndex:'98'}
          },
          'start' : {
            'animate' : {top:'-3em',opacity:'0'}
          },
          'next' : {
            'css' : {top:'3em',display:'block',opacity:'0',zIndex:'99'},
            'animate' : {top:'0',opacity:'1'}
          },
          'end' : {
            'css' : {zIndex:'98'}
          }
        }
      }
      plugin.init();
    }
      $.fn.simpleTicker = function(options) {
        return this.each(function() {
          if (undefined == $(this).data('simpleTicker')) {
            var plugin = new $.simpleTiecker(this, options);
            $(this).data('simpleTicker', plugin);
          }
        });
      }
    })(jQuery);

    $(function(){
      $.simpleTicker($('#js-ticker-roll'), {'effectType':'roll'});
    });

    // Empty Form Fields
    if (jQuery("body").hasClass('page-id-3686')) {​​​​​​​
      setTimeout(()=>{
          document.getElementById('wc-authorize-net-cim-credit-card-account-number').value  = '';
          document.getElementById('wc-authorize-net-cim-credit-card-expiry').value          = '';
          document.getElementById('wc-authorize-net-cim-credit-card-csc').value             = '';
          document.getElementById('wc-authorize-net-cim-credit-card-csc').type              = 'password';
      }, 1000);
    }

    // Remove links from Honor Rolls
    if (jQuery("body").hasClass('individual-honor-rolls') || jQuery("body").hasClass('corporates-foundations-honor-roll')) {​​​​​​​
        jQuery('.t-entry-title a').removeAttr('href');
    }
    
    

  });




